import React from 'react';
import Course from "./Course";

export interface Reservation {
    event_id: number,
    start_time: number
    course_id: number,
    loc_id?: number,
}

export default class Cart {

    constructor() {
        
    }

    private _courses: Array<Reservation> = [];

    public addEntry = (seat: Reservation) => {
        if (this.isSet(seat.event_id)) {
            return;
        }
        this._courses.push(seat);
    }

    public isSet = (event_id: number): boolean => {
        return this._courses.filter((r: Reservation) => r.event_id == event_id).length > 0;
    }

    public isCartEmpty = (): boolean => {
        return Object.values(this._courses).length == 0
    }

    public get cart(): Array<Reservation> {
        return this._courses;
    }

    public removeEntry = (entry: Reservation): void => {
        this._courses = this._courses.filter((r: Reservation) => r.event_id != entry.event_id);
    }
}
